import { Box, Text } from "@chakra-ui/react";


import ArrivalRatesPerDayTable from "../tables/ArrivalRatesPerDayTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";

const ArrivalRatesPerDay = ({ data, renderConfig, onRenderConfigChange }) => {


  return (
    <Box>
      {data.map((data, index) => {
        const { branchName, numServices } = data;
        const title = `${index + 1}. ${branchName}`;
        const insights = buildArrivalInsights(data, { scopeLabel: "Branch" });
        
        return (
          <Box key={index}>
            <h2>{title}</h2>
            <Text>{numServices} services</Text>
            <EnterpriseReportSummary
              title="Daily Arrival Demand Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            <ArrivalRatesPerDayTable
              data={data}
              index={index}
              renderConfig={renderConfig}
              onRenderConfigChange={onRenderConfigChange}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ArrivalRatesPerDay;
